import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as lodash from 'lodash';

@Injectable()
export class HttpService {

  constructor(
    private http: HttpClient
  ) { }

  public get(url: any, params: any = null, headers?: any, responseType?: any): Observable<any> {
    return this.http.get(url, { params, headers, responseType });
  }

  public post(url: any, data: any = null, options?: any): Observable<any> {
    return this.http.post(url, data, options);
  }

  public put(url: any, data: any = null, options?: any): Observable<any> {
    return this.http.put(url, data, options);
  }

  public delete(url: any, params: any = null, headers?: any): Observable<any> {
    return this.http.delete(url, { params, headers });
  }

  public postFile(url, data, options = {}): Observable<any> {
    const headers = new HttpHeaders();
    headers.append('Content-Type', 'multipart/form-data');
    headers.append('Accept', 'application/json');

    return this.http.post(url, data, lodash.merge({}, options, { headers }));
  }
}
